(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skimoji-buybox"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sm-buybox')) {
    customElements.define(
      'sm-buybox',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-sm-track]');
          this.thumbs = Array.from(this.querySelectorAll('[data-sm-thumb]'));
          this.sticky = this.querySelector('[data-sm-sticky]');
          this.form = this.querySelector('[data-sm-form]');

          this.addEventListener('change', (event) => {
            if (event.target.matches('input[name="id"]')) this.select(event.target);
          });

          this.thumbs.forEach((thumb, index) => {
            thumb.addEventListener('click', () => this.show(index));
          });

          if (this.track && this.thumbs.length) {
            this.track.addEventListener('scroll', () => this.syncThumbs(), { passive: true });
          }

          if (this.form && this.dataset.cartMode === 'drawer') {
            this.form.addEventListener('submit', (event) => this.addToCart(event));
          }

          const cta = this.querySelector('[data-sm-cta]');
          if (cta && this.sticky && 'IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(([entry]) => {
              const visible = !entry.isIntersecting;
              this.sticky.classList.toggle('is-visible', visible);
              this.sticky.inert = !visible;
            });
            this.observer.observe(cta);
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        addToCart(event) {
          if (!document.querySelector('sm-cart')) return;
          event.preventDefault();
          if (this.busy) return;
          this.busy = true;
          fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(this.form),
          })
            .then((response) => {
              if (!response.ok) throw new Error('add failed');
              return response.json();
            })
            .then(() => {
              document.dispatchEvent(new CustomEvent('sm:cart:added'));
            })
            .catch(() => {
              this.form.submit();
            })
            .finally(() => {
              this.busy = false;
            });
        }

        select(input) {
          this.querySelectorAll('.sm-pass').forEach((pass) => {
            pass.classList.toggle('is-selected', pass.contains(input));
          });
          this.querySelectorAll('[data-sm-now]').forEach((el) => {
            el.textContent = input.dataset.now;
          });
          const was = this.querySelector('[data-sm-was]');
          const save = this.querySelector('[data-sm-save]');
          if (was) {
            was.textContent = input.dataset.was;
            was.hidden = !input.dataset.was;
          }
          if (save) {
            save.textContent = input.dataset.save ? save.dataset.prefix + ' ' + input.dataset.save : '';
            save.hidden = !input.dataset.save;
          }
          const count = Number(input.dataset.count) || 1;
          this.querySelectorAll('[data-sm-design-row]').forEach((row, index) => {
            const active = index < count;
            row.hidden = !active;
            row.disabled = !active;
          });
        }

        show(index) {
          if (!this.track) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollTo({ left: index * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        }

        syncThumbs() {
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.thumbs.forEach((thumb, i) => {
            thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skimoji-header"]) return;
  try {
    
  if (!customElements.get('sm-cart')) {
    customElements.define(
      'sm-cart',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-sm-cart-dialog]');

          this.addEventListener('click', (event) => {
            const target = event.target;
            if (target.closest('[data-sm-cart-open]')) {
              this.open();
            } else if (target.closest('[data-sm-cart-close]') || target === this.dialog) {
              this.dialog.close();
            } else {
              const step = target.closest('[data-sm-qty]');
              if (step) this.change(step.dataset.line, step.dataset.quantity);
            }
          });

          this.onAdded = () => this.refresh().then(() => this.open());
          document.addEventListener('sm:cart:added', this.onAdded);
        }

        disconnectedCallback() {
          document.removeEventListener('sm:cart:added', this.onAdded);
        }

        open() {
          if (this.dialog && !this.dialog.open) this.dialog.showModal();
        }

        render(html) {
          const fresh = new DOMParser().parseFromString(html, 'text/html');
          const content = fresh.querySelector('[data-sm-cart-content]');
          const count = fresh.querySelector('[data-sm-cart-count]');
          const currentContent = this.querySelector('[data-sm-cart-content]');
          const currentCount = this.querySelector('[data-sm-cart-count]');
          if (content && currentContent) currentContent.innerHTML = content.innerHTML;
          if (count && currentCount) {
            currentCount.textContent = count.textContent;
            currentCount.hidden = count.hasAttribute('hidden');
          }
        }

        refresh() {
          const id = this.dataset.sectionId;
          return fetch(this.dataset.root + '?sections=' + encodeURIComponent(id))
            .then((response) => response.json())
            .then((data) => {
              if (data[id]) this.render(data[id]);
            })
            .catch(() => {});
        }

        change(line, quantity) {
          const id = this.dataset.sectionId;
          this.classList.add('is-busy');
          fetch(this.dataset.changeUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: [id] }),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.sections && data.sections[id]) this.render(data.sections[id]);
              else return this.refresh();
            })
            .catch(() => {
              window.location.href = this.dataset.cartUrl;
            })
            .finally(() => this.classList.remove('is-busy'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
